module.exports = __webpack_public_path__ + "static/media/republic-of-poland.ed9d5529.svg";